const envSettings = window;

export const Config = {
	api_rest_be: envSettings.API_REST_BE,
	backoffice_service: envSettings.BACKOFFICE_SERVICE,
	backoffice_user_service: envSettings.BACKOFFICE_USER_SERVICE,
	application: envSettings.APPLICATION,
	client_version: envSettings.CLIENT_VERSION,
	environment: envSettings.ENVIRONMENT,
	language_url: envSettings.LANGUAGE_URL,
	auth_service: envSettings.AUTH_SERVICE,
	token_service: envSettings.TOKEN_SERVICE,
	client_id: envSettings.CLIENT_ID,
	redirect_uri: envSettings.REDIRECT_URI,
	user_enrollment_redirect_uri: envSettings.USER_ENROLLMENT_REDIRECT_URI,
	token_redirect_uri: envSettings.TOKEN_REDIRECT_URI,
	federate_internal_login: envSettings.FEDERATE_INTERNAL_LOGIN,
	federate_external_login: envSettings.FEDERATE_EXTERNAL_LOGIN,
	logger_server: envSettings.LOGGER_SERVER,
	user_enrollment: envSettings.USER_ENROLLMENT,
	logout_user: envSettings.LOGOUT_USER,
	user_enrollment_otp: envSettings.USER_ENROLLMENT_OTP,
	get_claims: envSettings.GET_CLAIMS,
	orders_build: envSettings.ORDERS_BUILD,
	confirm_payment: envSettings.CONFIRM_PAYMENT,
	start_enrollment: envSettings.START_ENROLLMENT,
	start_payment: envSettings.START_PAYMENT,
	change_password_forced_uri: envSettings.CHANGE_PASSWORD_FORCED_URI,
	change_password_uri: envSettings.CHANGE_PASSWORD_URI,
	success_result_url: envSettings.SUCCESS_RESULT_URL,
	failure_result_url: envSettings.FAILURE_RESULT_URL,
	cancel_result_url: envSettings.CANCEL_RESULT_URL,
	npg_build_js_url: envSettings.NPG_BUILD_JS_URL
};
